import React from 'react'

function topslider() {
    
        return (           
            <section id="slider" className="hero odd vh-100">
                <div className="no-slider animation ">
                    <div className="vh-100">
                        <div className="vh-100">                            
                            <div className="slide-content row vh-100">
                                <div className="col-12 d-flex inner">
                                    <div >
                                        <h1 className="title container-sm" data-aos="zoom-out-up" data-aos-delay="400">
                                        <span style={{fontWeight:"200"}}>Technology is best</span> when it brings people <span className="text-white">together</span>. <br></br> 
                                        </h1>
                                        <p className="text-center">Lets Talk! <i className="fa fa-smile"></i></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>            
        )    
}



export default topslider;
